import { extendMantineTheme } from "@synqup/ui/src/styles/mantine";

// Extend the base mantine theme with any web-specific customizations
export const theme = extendMantineTheme({
  // Add any web-specific theme overrides here
});
